import { FavoritePageEnum } from '../enums';

export const PageTitles: Record<FavoritePageEnum, string> = {
  [FavoritePageEnum.AGENTIC_WORKFLOWS]: 'GTMCanvas',
  [FavoritePageEnum.AI_GENERATED_CONTENT]: 'AIGeneratedContent',
  [FavoritePageEnum.BOUNCE_INTEL]: 'BounceIntel',
  [FavoritePageEnum.CUSTOM_ENRICHMENT]: 'Custom Enrichment',
  [FavoritePageEnum.DASHBOARD]: 'SalesIntel',
  [FavoritePageEnum.FORMS_INTEL]: 'FormsIntel',
  [FavoritePageEnum.HUBSPOT_ENRICHMENT]: 'Enrich Data',
  [FavoritePageEnum.ICP_INTEL]: 'ICPIntel',
  [FavoritePageEnum.INBOX_INTEL]: 'InboxIntel',
  [FavoritePageEnum.LISTS]: 'Lists',
  [FavoritePageEnum.PROSPECT_INTEL]: 'ProspectIntel (Search)',
  [FavoritePageEnum.RESEARCH_ON_DEMAND]: 'Research on Demand',
  [FavoritePageEnum.REP_INTEL]: 'RepIntel',
  [FavoritePageEnum.SAVED_SEARCHES]: 'Saved Searches',
  [FavoritePageEnum.VISITOR_INTEL]: 'VisitorIntel',
}
